'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _ProviderStyles = require('./ProviderStyles.js');

var styles = _interopRequireWildcard(_ProviderStyles);

var _photographyClientLib = require('@wix/photography-client-lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types, no-case-declarations, no-mixed-operators */
var ProviderIntent = function (_Component) {
  (0, _inherits3.default)(ProviderIntent, _Component);

  function ProviderIntent(props) {
    (0, _classCallCheck3.default)(this, ProviderIntent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProviderIntent.__proto__ || (0, _getPrototypeOf2.default)(ProviderIntent)).call(this, props));

    _this.handleMessageReceived = _this.handleMessageReceived.bind(_this);
    _this.onBackToEditor = _this.onBackToEditor.bind(_this);
    _this.handleWixStyleChanged = _this.handleWixStyleChanged.bind(_this);
    _this.setTabIndex = _this.setTabIndex.bind(_this);
    _this.api = props.api;
    var anonymousUserId = _this.api.getAnonymousUserId();
    var providerData = null;
    var providerId = null;
    var debugApp = props.debugApp || _photographyClientLib.window.debugApp;
    var connectedProviders = props.connectedProviders;

    _this.api.isVisualFocusEnabled().then(function (isEnabled) {
      _this.setState({ isAccessible: isEnabled, readyToRender: true });
    });

    if (connectedProviders) {
      var providerDataProps = _this.getProviderDataFromConnectedProviders(connectedProviders);
      providerData = providerDataProps.providerData;
      providerId = providerDataProps.providerId;
    }

    _this.state = {
      providerData: providerData,
      providerId: providerId,
      token: _this.getUUID(),
      anonymousUserId: anonymousUserId,
      isAccessible: false,
      providerReady: false,
      debugApp: debugApp,
      readyToRender: false
    };
    return _this;
  }

  (0, _createClass3.default)(ProviderIntent, [{
    key: 'getUUID',
    value: function getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: 'isDashboard',
    value: function isDashboard() {
      return this.api.getViewMode() === 'dashboard';
    }
  }, {
    key: 'isEditor',
    value: function isEditor() {
      return this.api.getViewMode() === 'editor';
    }
  }, {
    key: 'isPreview',
    value: function isPreview() {
      return this.api.getViewMode() === 'preview';
    }
  }, {
    key: 'handleWixStyleChanged',
    value: function handleWixStyleChanged() {
      var _this2 = this;

      // This timeout will let the params a chance to be set
      setTimeout(function () {
        _this2.sendStylesToProvider();
      }, 1);
    }
  }, {
    key: 'getProviderDataFromConnectedProviders',
    value: function getProviderDataFromConnectedProviders(connectedProviders) {
      var providerData = null;
      var providerId = null;

      if (connectedProviders) {
        providerId = (0, _keys2.default)(connectedProviders)[0];
        providerData = connectedProviders[providerId];
      }

      return { providerData: providerData, providerId: providerId };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextProviderData = this.getProviderDataFromConnectedProviders(nextProps.connectedProviders);
      var currentProviderId = this.getProviderDataFromConnectedProviders(this.props.connectedProviders);

      if (nextProviderData.providerId !== currentProviderId.providerId) {
        this.intentFrame = null;
        this.setState({
          providerData: nextProviderData.providerData,
          providerId: nextProviderData.providerId,
          providerReady: false
        });
      }
    }
  }, {
    key: 'raiseEvent',
    value: function raiseEvent(eventType, data, resolve, reject) {
      if (this.props.onMessageReceived) {
        this.props.onMessageReceived(eventType, data, resolve, reject, this.state.providerId);
      }
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex(idx) {
      if (this.intentFrame) {
        this.intentFrame.tabIndex = idx;
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return !this.intentFrame; //prevent iframe from refreshing
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _photographyClientLib.window.addEventListener('message', this.handleMessageReceived);
      this.api.attachEditModeChanged(this.onBackToEditor);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _photographyClientLib.window.removeEventListener('message', this.handleMessageReceived);
      this.api.dettachEditModeChanged(this.onBackToEditor);
    }
  }, {
    key: 'isSite',
    value: function isSite() {
      return !this.isEditor() && !this.isPreview();
    }
  }, {
    key: 'onBackToEditor',
    value: function onBackToEditor() {
      var _this3 = this;

      if (this.props.hiddenFromEditor === true && !this.isSite()) {
        // If we don't do the following checks then if the hidden page is not visible, the SDK will make a short jump to that page before navigating to home..
        // This way we make sure that the current pageId is not a hidden page - thus we should not navigate at all..
        this.api.getCurrentPageId().then(function (currentPageId) {
          _this3.api.getSitePages().then(function (arrPages) {
            var isInSitePages = arrPages.some(function (page) {
              return page.id === currentPageId;
            });
            if (!isInSitePages) {
              _this3.backHome();
            }
          });
        });
      }
    }
  }, {
    key: 'backHome',
    value: function backHome(payload) {
      var _this4 = this;

      if (!this.hasWixSdk()) {
        return;
      } else {
        if (!this.isEditor()) {
          try {
            this.api.replaceSectionState('/');
          } catch (e) {
            console.error('failed replacing section state', e);
          }
        }

        this.api.getSitePages().then(function (arrPages) {
          var homepage = (arrPages || []).find(function (page) {
            return page.isHomepage;
          });
          if (homepage) {
            var homepageId = homepage.id;
            if (payload) {
              if (payload.openCart) {
                localStorage.setItem('openCart', true);
              }
            }

            _this4.api.navigateToPage(homepageId);
          }
        });
      }
    }
  }, {
    key: 'getSiteUrlsBundle',
    value: function getSiteUrlsBundle() {
      var arrPromises = [];
      var returnPromise = null;
      if (!this.isDashboard()) {
        var dashboardPromise = _promise2.default.resolve(null);

        arrPromises.push(this.api.getSiteInfo());
        arrPromises.push(this.api.getSectionUrl('checkout_page'));
        arrPromises.push(this.api.getSectionUrl('thank_you_page'));

        if (this.isEditor()) {
          dashboardPromise = this.api.getDashboardAppUrl().then(function (url) {
            // For some reason - the value does not have the protocol section ( http: ), so we add it ourselves..
            return (0, _urijs2.default)(url).protocol('http').search({ appState: '#' }).toString();
          });
        }
        arrPromises.push(dashboardPromise);

        returnPromise = _promise2.default.all(arrPromises).then(function (results) {
          var siteUrl = results[0].baseUrl;
          var url = results[0].url;
          var checkoutUrl = (0, _urijs2.default)(results[1].url).toString();
          var thankYouUrl = (0, _urijs2.default)(results[2].url).toString();
          var dashboardUrl = results[3];
          var result = {
            checkoutUrl: checkoutUrl,
            thankYouUrl: thankYouUrl,
            siteUrl: siteUrl,
            url: url,
            dashboardUrl: dashboardUrl
          };
          return result;
        });
      } else {
        returnPromise = _promise2.default.reject('Cannot get urls when viewMode is "dashboard"');
      }

      return returnPromise;
    }
  }, {
    key: 'sendStylesToProvider',
    value: function sendStylesToProvider() {
      var _this5 = this;

      var _props = this.props,
          preventStyles = _props.preventStyles,
          styleParams = _props.styleParams;

      if (!preventStyles) {
        styles.getStyles(styleParams || {}, this.api).then(function (css) {
          _this5.postMessage(_providerEvents2.default.css, css);
        });
      }
    }
  }, {
    key: 'hasWixSdk',
    value: function hasWixSdk() {
      var wixApi = this.api.wixApi;

      return wixApi && !wixApi.isMock;
    }
  }, {
    key: 'handleMessageReceived',
    value: function handleMessageReceived(event) {
      var _this6 = this;

      var providerData = this.state.providerData;

      if (event.data && this.hasWixSdk() && this.api.isStyleChanged(event.data.type)) {
        this.handleWixStyleChanged();
      }
      // This check is because the provider may get messages that did not originate from the provider.. So we might get messages before the provider is loaded.
      if (providerData) {
        var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
        var data = event.data;
        var intentUrl = this.getProviderBaseUrl();

        if (intentUrl && intentUrl.indexOf(origin) === 0) {
          var type = data.type,
              token = data.token,
              payload = data.payload,
              callbackId = data.callbackId;


          var resolve = function resolve() {};
          var reject = function reject() {};
          if (callbackId) {
            resolve = function resolve(payload) {
              _this6.postMessage(_providerEvents2.default.callback, {
                payload: payload,
                callbackId: callbackId,
                resolved: true
              });
            };
            reject = function reject(payload) {
              _this6.postMessage(_providerEvents2.default.callback, {
                payload: payload,
                callbackId: callbackId,
                resolved: false
              });
            };
          }
          try {
            if (this.state.token && token === this.state.token) {
              if (process.env.NODE_ENV === 'development') {
                console.log('Provider intent message received: type: ' + type + ' | intent ' + this.props.intent);
              }
              switch (type) {
                case _providerEvents2.default.sdkReady:
                  if (this.loader) {
                    this.loader.style.display = 'none';
                  }
                  this.setState({ providerReady: true }, function () {
                    _this6.sendStylesToProvider();
                  });
                  this.api.applicationLoaded();
                  console.timeEnd('Provider intent iframe load time - ' + this.props.intent);
                  break;
                case _providerEvents2.default.backHome:
                  this.backHome(payload);
                  break;
                case _providerEvents2.default.navigateToUrl:
                  var url = payload.url;

                  _photographyClientLib.window.top.location.href = url;
                  break;
                case _providerEvents2.default.getSiteUrls:
                  this.getSiteUrlsBundle().then(function (urls) {
                    resolve(urls);
                  }).catch(function (err) {
                    reject(err);
                  });
                  break;
                case _providerEvents2.default.getStyles:
                  styles.getStyles(this.props.styleParams || {}, this.api).then(function (css) {
                    resolve(css);
                  });
                  break;
                default:
                  break;
              }

              this.raiseEvent(type, payload, resolve, reject, providerData.providerId);
            }
          } catch (error) {
            console.error('Error handling provider event. Type: ' + type + ' | payload: ' + payload, error);
            if (reject) {
              reject('Error');
            }
          }
        }
      } else {
        // TODO: do something smart
      }
    }
  }, {
    key: 'postMessage',
    value: function postMessage(type, payload) {
      var token = this.state.token;

      var intentUrl = this.getProviderBaseUrl();

      var success = false;
      if (this.intentFrame && type && payload) {
        var obj = { type: type, token: token, payload: payload };
        var providerReady = this.state.providerReady;

        if (providerReady) {
          this.intentFrame.contentWindow.postMessage(obj, intentUrl);
          success = true;
        } else {
          // console.error(`cannot send provider message - type: ${type} | intent: ${intent} | payload:`, payload);
        }
      }
      return success;
    }
  }, {
    key: 'onFrameCreated',
    value: function onFrameCreated(element) {
      console.time('Provider intent iframe load time - ' + this.props.intent);
      this.intentFrame = element;
      if (this.props.onFrameCreated) {
        this.props.onFrameCreated();
      }
    }
  }, {
    key: 'hasDebug',
    value: function hasDebug() {
      var debugApp = this.state.debugApp;


      return debugApp && (typeof debugApp === 'undefined' ? 'undefined' : (0, _typeof3.default)(debugApp)) === (0, _typeof3.default)('');
    }
  }, {
    key: 'getProviderBaseUrl',
    value: function getProviderBaseUrl() {
      var url = null;
      var _state = this.state,
          providerData = _state.providerData,
          debugApp = _state.debugApp;
      var intent = this.props.intent;


      if (providerData && intent) {
        var widgets = providerData.widgets;

        if (widgets) {
          var baseUrl = widgets[intent];
          if (baseUrl) {
            url = baseUrl.url;

            if (this.hasDebug()) {
              var providerHostKey = 'ph_pvdr_host_';
              var arrDebugAppParts = debugApp.split('|');
              var newHostPart = arrDebugAppParts.find(function (part) {
                return part.indexOf(providerHostKey) === 0;
              });
              if (newHostPart) {
                var encodedHost = newHostPart.substring(providerHostKey.length);
                var newHost = decodeURIComponent(encodedHost);
                url = (0, _urijs2.default)(url).hostname(newHost).toString();
              }
            }
          }
        }
      }

      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _state2 = this.state,
          providerData = _state2.providerData,
          anonymousUserId = _state2.anonymousUserId,
          debugApp = _state2.debugApp,
          readyToRender = _state2.readyToRender;


      if (!providerData || !providerData.widgets || !readyToRender) {
        return _react2.default.createElement('div', { className: 'circle-preloader' });
      }

      var _props2 = this.props,
          intent = _props2.intent,
          locale = _props2.locale,
          deviceType = _props2.deviceType,
          viewMode = _props2.viewMode,
          additionalParams = _props2.additionalParams,
          customAdditionalParams = _props2.customAdditionalParams,
          additionalPath = _props2.additionalPath,
          tabIndex = _props2.tabIndex;

      // if (!deviceType) {
      //   console.warn('no device type! TODO: take from url');
      // }

      var providerId = providerData.providerId,
          signedInstance = providerData.signedInstance;


      var urlAdditionalParams = (0, _urijs2.default)(_photographyClientLib.window.location.href).search(true).additionalParams;
      var objUrlAdditionalParams = {};
      if (urlAdditionalParams) {
        objUrlAdditionalParams = (0, _urijs2.default)('/').search(urlAdditionalParams).search(true);
      }
      if (customAdditionalParams) {
        objUrlAdditionalParams = customAdditionalParams;
      }

      var realLocale = locale || this.api.getLocale();
      var realDeviceType = deviceType || this.api.getDeviceType();
      var cachekiller = Date.now();
      var url = this.getProviderBaseUrl();
      var realViewMode = viewMode || this.api.getViewMode();
      var realAdditionalParams = additionalParams || {};
      if (providerId === '147bec5f-d87e-d37b-b5cf-36f47c1815b4' || providerId === '14a0ee97-918b-2f0c-43f1-42e67948716b') {
        // This is specific to the Wix provider.
        realAdditionalParams.biToken = this.api.getBiToken();
      }
      if (this.hasDebug()) {
        realAdditionalParams.debugApp = debugApp;
      }
      var fullUrl = url ? (0, _urijs2.default)(url).segment(additionalPath || '').search((0, _assign2.default)({
        pInstance: signedInstance,
        locale: realLocale,
        deviceType: realDeviceType,
        cachekiller: cachekiller,
        anonymousUserId: anonymousUserId,
        viewMode: realViewMode,
        a11y: this.state.isAccessible
      }, realAdditionalParams || {}, objUrlAdditionalParams, { token: this.state.token })) : '';
      var id = intent + '-frame';
      var iframeIndex = tabIndex;
      var renderComponent = _react2.default.createElement('iframe', {
        tabIndex: iframeIndex,
        src: fullUrl,
        id: id,
        ref: function ref(r) {
          return _this7.onFrameCreated(r);
        },
        style: {
          height: '100%',
          width: '100%',
          border: 0,
          display: 'block'
        }
      });
      var customIframeStyle = this.props.customIframeStyle || {};
      var providerIntentStyle = (0, _extends3.default)({}, customIframeStyle, {
        height: '100%',
        width: '100%'
      });
      return _react2.default.createElement(
        'div',
        { className: 'provider-intent-wrapper', style: providerIntentStyle },
        _react2.default.createElement('div', { className: 'circle-preloader', ref: function ref(_ref) {
            return _this7.loader = _ref;
          } }),
        renderComponent
      );
    }
  }]);
  return ProviderIntent;
}(_react.Component);
/* eslint-enable react/prop-types, no-case-declarations, no-mixed-operators */

ProviderIntent.defaultProps = {
  styleParams: {}
};

exports.default = ProviderIntent;